var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PartnerHeader',{attrs:{"img_header":_vm.header_image,"header":"ข้อมูลร้านค้า","link_back":""}}),_c('MenuMember'),_c('CustomerDashboard')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }